import React from 'react'
import Head from 'next/head'
import { OnSetServicesWrapper } from '../components/onSetServices/styles'
import HeroImage from '../../public/on-set-services/on-set-services-hero.jpg'
import Hero from '../components/Hero'
import LightsCameraGlam from '../components/onSetServices/lightsCameraGlam'
import WhyChecklist from '../components/why-checklist'
import WhyGlamsquadImage from '../../public/on-set-services/why-glamsquad.png'
import ReviewScroll from '../components/review-scroll'
import FAQ from '../faq'
import BookEvent from '../components/book-event'

const OnSetServices = () => {
  const handleClick = () => {
    if (typeof window !== 'undefined') {
      window.location.href = '/events/contact?origin=on-set'
    }
  }

  const whyHighlights = [
    'Flexible booking with hourly, half-day, and full-day rate options',
    `We'll meet you anywhere in the U.S. (travel fees may apply)`,
    'Easily re-book the same team for future glam needs',
    'White glove service with a dedicated concierge team',
    'Pros are hand-picked based on your vision and glam needs',
  ]

  const reviews = [
    {
      quote: `"The Glamsquad pros have been amazing to work with on set over the years. No matter what city we're in, they ensure the photo shoot process is easy and seamless for us, and we couldn't be happier with the results. We are so appreciative for their work with our models' beautiful hair and makeup looks."`,
      name: 'Alexandra Macon, Over The Moon Founder',
    },
    {
      quote: `"Everyone absolutely adored the artists. They created such a positive, welcoming energy and made our guests feel truly pampered ahead of the beach photoshoot. Not only did they make everyone look beautiful, but the experience itself was such a special part of the day." `,
      name: 'Cocokind',
    },
  ]

  const FAQ_URL = '/faq'

  const FAQ_DATA = [
    {
      id: 1,
      title: 'What services do you provide on set?',
      body: `Glamsquad has vast experience with photoshoots, runway shows, TV appearances, and beyond. We'll work closely with you to customize our on-set beauty services to fit your needs. Please email <a href="mailto:events@glamsquad.com">events@glamsquad.com</a> for more info.`,
    },
    {
      id: 2,
      title: 'Is there a booking minimum for on-set services?',
      body: `On-set services are booked at an hourly rate with a two-hour minimum per service (hair, makeup, or nails). `,
    },
  ]

  return (
    <>
      <Head>
        <title>On-Set Beauty Services | GLAMSQUAD</title>
        <meta name="description" content="Hair, makeup, and nail pros on set for photoshoots, film, TV, and runway. Hourly, half-day, and full-day rates. Camera-ready talent, nationwide." />
        <link rel="canonical" href="https://glamsquad.com/on-set" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="On-Set Beauty Services | GLAMSQUAD" />
        <meta property="og:description" content="Hair, makeup, and nail pros on set for photoshoots, film, TV, and runway. Hourly, half-day, and full-day rates. Camera-ready talent, nationwide." />
        <meta property="og:url" content="https://glamsquad.com/on-set" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: FAQ_DATA.map((q) => ({
              '@type': 'Question',
              name: q.title,
              acceptedAnswer: { '@type': 'Answer', text: q.body },
            })),
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Service',
            name: 'On-Set Beauty Services',
            serviceType:
              'On-set hair, makeup, and nail services for productions',
            description:
              'On-set hair, makeup, and nail pros for photoshoots, film, TV, and runway, with hourly, half-day, and full-day rates.',
            provider: { '@id': 'https://glamsquad.com/#organization' },
            areaServed: { '@type': 'Country', name: 'United States' },
            url: 'https://glamsquad.com/on-set',
          })}
        </script>
      </Head>
      <OnSetServicesWrapper>
        <Hero
          className="hero-component"
          header="ON-SET SERVICES"
          subheader="From photoshoots and brand campaigns to film, TV, and runway, our on-set hair, makeup, and nail services get your talent camera-ready in a flash."
          buttonTitle="Get Started"
          image={HeroImage}
          imageAlt="GLAMSQUAD glam team doing hair and makeup for talent on set"
          ctaClick={handleClick}
          hideCTA={false}
        />
        <LightsCameraGlam {...{ handleClick }} />
        <WhyChecklist
          buttonTitle="Book On-Set Services"
          headerTitle="Why Glamsquad?"
          reasons={whyHighlights}
          image={WhyGlamsquadImage}
          imageAlt="GLAMSQUAD beauty pro styling talent's hair and makeup on a photoshoot set"
          handleClick={handleClick}
        />
        <ReviewScroll reviews={reviews} />
        <div className="faq-wrapper">
          <FAQ data={FAQ_DATA} url={FAQ_URL} />
        </div>
        <BookEvent title="Ready to book on-set services?" {...{ handleClick }} />
      </OnSetServicesWrapper>
    </>
  )
}

export default OnSetServices
